<template>
  <div class="py-4 mx-auto max-w-7xl" v-if="property">
    <BreadCrumb :propertyDetails="property" />
    <PropertyImages :property="property" />
    <div class="flex flex-col w-full md:flex-row md:space-x-2">
      <div class="md:w-8/12">
        <div>
          <div class="flex flex-col w-full mt-5 md:hidden">
            <h1 class="text-2xl font-medium text-center">
              {{ formattedAmount(Number(property.price, 2)) }}
              <span v-if="property.rent_payment_frequency"
                >/{{ property.rent_payment_frequency }}</span
              >
            </h1>
            <div
              class="flex justify-between pt-5 space-x-2"
              v-show="showContactInfoButtons"
            >
              <a
                :href="showPhoneDetails"
                @click="showPhoneNumber"
                class="bg-secondary cursor-pointer w-full text-white rounded flex items-center justify-center hover:bg-red-500 h-[48px] font-semibold"
              >
                <CallSvg color="white" height="5" width="5" />
                <span class="pl-1">Call</span>
              </a>
              <button
                @click="sendEmail"
                class="bg-secondary cursor-pointer w-full text-white rounded flex items-center justify-center hover:bg-red-500 h-[48px] font-semibold"
              >
                <EmailSvg color="white" height="5" width="5" />
                <span class="pl-1">Email</span>
              </button>
              <button
                class="flex items-center cursor-pointer justify-center w-full text-sm font-bold text-white bg-green-500 rounded hover:bg-green-600 h-[48px]"
                @click="shareWhatsApp"
              >
                <WhatsAppSvg color="white" height="5" width="5" />
                <span class="pl-1"> WhatsApp</span>
              </button>
            </div>

            <div
              class="p-4 mt-3 rounded-md bg-stone-50"
              v-if="isAuthenticated && showContactDetails"
            >
              <div
                class="p-4 mt-3 rounded-md bg-stone-50"
                v-show="showContactDetails"
              >
                <!-- Contact details -->
                <div class="flex justify-between" v-if="property.agent">
                  <div class="flex items-center w-7/12">
                    <CallSvg color="secondary" height="4" width="4" />
                    <span class="pl-2 text-secondary">{{
                      property.agent.phone
                    }}</span>
                  </div>
                  <div class="flex space-x-2">
                    <div class="w-6/12 p-2 bg-white rounded">
                      <button @click="sendEmail">
                        <EmailSvg color="secondary" height="5" width="5" />
                      </button>
                    </div>
                    <div class="w-6/12 p-2 bg-white rounded">
                      <button @click="shareWhatsApp">
                        <WhatsAppSvg color="secondary" height="5" width="5" />
                      </button>
                    </div>
                  </div>
                </div>
                <hr class="my-1" />
                <div v-if="property.agent">
                  <p class="">
                    <a
                      :href="
                        $router.resolve({
                          name: 'AgentView',
                          params: {
                            id: property.agent.id,
                            slug: property.agent.name
                              ? $sanitizeTitle(property.agent.name)
                              : '',
                          },
                        }).href
                      "
                      class="text-blue-400"
                    >
                      {{ property.agent.name }}
                    </a>
                    Speaks English
                  </p>
                  <p class="pt-2">
                    Mention the reference:
                    <span class="font-semibold">{{ property.reference }}</span>
                  </p>
                </div>
              </div>
            </div>

            <div v-show="message">
              <p class="text-sm text-center text-red-500">
                {{ message }}
              </p>
            </div>
            <hr class="my-5" />
            <button
              @click="handleAddItem(property)"
              class="flex items-center justify-center w-40 mx-auto text-sm border border-gray-200 rounded hover:bg-gray-50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                :class="{
                  'w-3 h-3 md:w-6 md:h-6': !isInWishlist(property),
                  'fill-secondary stroke-secondary w-3 h-3 md:w-6 md:h-6':
                    isInWishlist(property),
                }"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                />
              </svg>
              <span class="pl-1">Save to shortlist</span>
            </button>
          </div>
        </div>
        <PropertyDescription :property="property" />
      </div>

      <div class="flex flex-col pr-2 pl-1 mt-8 md:w-[435px]">
        <div class="hidden md:flex md:flex-col">
          <div class="sticky top-2">
            <div
              class="flex flex-col w-full p-5 bg-white border border-gray-100 shadow-md"
            >
              <h1 class="text-2xl font-medium text-center">
                {{ formattedAmount(Number(property.price, 2)) }}
                <span v-if="property.rent_payment_frequency"
                  >/{{ property.rent_payment_frequency }}</span
                >
              </h1>
              <div
                class="flex justify-between pt-5 space-x-2"
                v-show="showContactInfoButtons"
              >
                <a
                  :href="showPhoneDetails"
                  @click="showPhoneNumber"
                  class="bg-secondary cursor-pointer w-full text-white rounded flex items-center justify-center hover:bg-red-500 h-[48px] font-semibold"
                >
                  <CallSvg color="white" height="5" width="5" />
                  <span class="pl-1">Call</span>
                </a>
                <button
                  @click="sendEmail"
                  class="bg-secondary cursor-pointer w-full text-white rounded flex items-center justify-center hover:bg-red-500 h-[48px] font-semibold"
                >
                  <EmailSvg color="white" height="5" width="5" />
                  <span class="pl-1">Email</span>
                </button>
                <button
                  @click="shareWhatsApp"
                  class="flex items-center cursor-pointer justify-center w-full text-sm font-bold text-white bg-green-500 rounded hover:bg-green-600 h-[48px]"
                >
                  <WhatsAppSvg color="white" height="5" width="5" />
                  <span class="pl-1"> WhatsApp</span>
                </button>
              </div>

              <div
                class="p-4 mt-3 rounded-md bg-stone-50"
                v-if="isAuthenticated && showContactDetails"
              >
                <div
                  class="p-4 mt-3 rounded-md bg-stone-50"
                  v-show="showContactDetails"
                >
                  <!-- Contact details -->
                  <div class="flex justify-between" v-if="property.agent">
                    <div class="flex items-center w-7/12">
                      <CallSvg color="secondary" height="4" width="4" />
                      <span class="pl-2 text-secondary">{{
                        property.agent.whatsapp_number
                      }}</span>
                    </div>
                    <div class="flex space-x-2">
                      <div class="w-6/12 p-2 bg-white rounded">
                        <a
                          :href="
                            'mailto:' +
                            property.agent.email +
                            '?subject=Property Information  &body=Hi, I found your property with ref:' +
                            property.agent.reference +
                            ' on hutloop. Please contact me. Thank you.!'
                          "
                        >
                          <EmailSvg color="secondary" height="5" width="5" />
                        </a>
                      </div>
                      <div class="w-6/12 p-2 bg-white rounded">
                        <a
                          target="__blank"
                          :href="
                            'https://wa.me/' +
                            property.agent.whatsapp_number +
                            '?text=Hi, I found your property with ref:' +
                            property.reference +
                            ' on hutloop. Please contact me. Thank you.!'
                          "
                        >
                          <WhatsAppSvg color="secondary" height="5" width="5" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <hr class="my-1" />
                  <div v-if="property.agent">
                    <p class="">
                      <a
                        :href="
                          $router.resolve({
                            name: 'AgentView',
                            params: {
                              id: property.agent.id,
                              slug: property.agent.name
                                ? $sanitizeTitle(property.agent.name)
                                : '',
                            },
                          }).href
                        "
                        class="text-blue-400"
                      >
                        {{ property.agent.name }}
                      </a>
                      Speaks English
                    </p>
                    <p class="pt-2">
                      Mention the reference:
                      <span class="font-semibold">{{
                        property.reference
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>

              <div v-show="message">
                <p class="text-sm text-center text-red-500">
                  {{ message }}
                </p>
              </div>

              <div
                class="flex flex-row items-center mt-5"
                v-if="property.agent"
              >
                <img
                  v-if="property.agent.photo"
                  :src="property.agent.photo"
                  class="w-[64px] h-[64px] rounded-full"
                  alt=""
                />
                <div v-else class="p-8 bg-gray-200 rounded-full"></div>
                <p class="pl-1">
                  {{ property.agent.name }}
                </p>
              </div>
              <hr class="my-5" />
              <button
                @click="handleAddItem(property)"
                class="flex items-center justify-center w-40 mx-auto text-sm border border-gray-200 rounded hover:bg-gray-50"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  :class="{
                    'w-3 h-3 md:w-6 md:h-6': !isInWishlist(property),
                    'fill-secondary stroke-secondary w-3 h-3 md:w-6 md:h-6':
                      isInWishlist(property),
                  }"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                  />
                </svg>
                <span class="pl-1">Save to shortlist</span>
              </button>
            </div>
          </div>
          <div>
            <PropertySidebar :property="property" />
          </div>
        </div>

        <div class="relative items-center justify-center hidden md:flex">
          <div class="sticky top-0">
            <div
              class="flex items-center justify-center mt-8"
              v-show="sideLong"
            >
              <a
                v-for="ad in sideLong"
                :key="ad.id"
                :href="resolveAdUrl(ad)"
                @click.prevent="handleAdClick(ad, routeName)"
                @mouseover="handleAdHoverStart()"
                @mouseout="handleAdHoverEnd(ad)"
              >
                <img
                  :src="ad.photo"
                  class="md:w-[300px] h-[600px] px-2 mx-auto md:px-0"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <SimilarProperties :properties="same_area_properties" />
</template>

<script>
import { ref, onMounted, watch } from "vue";

import SimilarProperties from "@/features/property/SimilarProperties.vue";
import { state as wishlistState, addItem } from "@/composables/useWishlist";
import PropertyDescription from "@/features/property/DetailsView.vue";
import PropertySidebar from "@/features/property/PropertySidebar.vue";
import PropertyImages from "@/features/property/ImagesView.vue";
import BreadCrumb from "@/features/property/BreadCrumb.vue";
import WhatsAppSvg from "@/components/svg/WhatsAppSvg.vue";
import EmailSvg from "@/components/svg/EmailSvg.vue";
import CallSvg from "@/components/svg/CallSvg.vue";
import { useAds } from "@/composables/useAds";
import useAuth from "@/composables/useAuth";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import axios from "axios";

export default {
  components: {
    BreadCrumb,
    PropertyImages,
    PropertyDescription,
    SimilarProperties,
    PropertySidebar,
    CallSvg,
    EmailSvg,
    WhatsAppSvg,
  },
  setup() {
    const { state: authState } = useAuth();
    const isAuthenticated = ref(authState.isAuthenticated);

    watch(
      () => authState.isAuthenticated,
      (newVal) => {
        isAuthenticated.value = newVal;
      }
    );

    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const base_url = store.state.baseUrl;
    const property = ref(null);
    const same_area_properties = ref(null);
    const showPhoneDetails = ref(null);
    const message = ref(null);
    const showContactInfoButtons = ref(true);
    const showContactDetails = ref(false);
    const townId = ref(null);
    const routeName = router.currentRoute.value.fullPath;

    const {
      sideLong,
      handleAdClick,
      handleAdHoverStart,
      handleAdHoverEnd,
      resolveAdUrl,
      loadAds,
    } = useAds();

    onMounted(() => {
      axios
        .get(`${base_url}property/${route.params.id}`)
        .then((response) => {
          property.value = response.data.data;
          townId.value = property.value.town.id;
          getPropertiesByTown(townId.value);
        })
        .catch((error) => console.log(error));
      loadAds();
    });

    const isInWishlist = (property) => {
      return wishlistState.wishlist.some((item) => item.id === property.id);
    };

    const handleAddItem = (property) => {
      addItem(property);
    };

    const getPropertiesByTown = (townId) => {
      if (townId) {
        axios
          .get(`${base_url}get-properties-by-towns/${townId}`)
          .then((response) => {
            same_area_properties.value = response.data.data;
          })
          .catch((error) => console.log(error));
      }
    };

    const shareWhatsApp = () => {
      if (isAuthenticated.value == true) {
        const message = `Hi, I found your property with ref: ${property.value.reference} on Hutloop. Please contact me. Thank you.!`;
        const showWhatsAppDetails = `https://api.whatsapp.com/send?phone=${
          property.value.agent.whatsapp_number
        }&text=${encodeURIComponent(message)}`;
        window.open(showWhatsAppDetails, "_blank");
      } else {
        message.value = "Login to view agent contact details";
      }
    };

    const sendEmail = () => {
      if (isAuthenticated.value == true) {
        const showEmailDetails = `mailto: 
          ${property.value.agent.email}
          ?subject=Hutloop Property  &body=Hi, I found your property with ref: ${property.value.reference} on Hutloop. Please contact me. Thank you.!`;

        window.open(showEmailDetails);
      } else {
        message.value = "Login to view agent contact details";
      }
    };

    const showPhoneNumber = () => {
      showContactInfoButtons.value = false;
      if (isAuthenticated.value == true) {
        showContactDetails.value = true;
        showPhoneDetails.value = "tel:" + property.value.agent.phone;
      } else {
        message.value = "Login to view agent contact details";
      }
    };

    return {
      sideLong,
      handleAdClick,
      handleAdHoverStart,
      handleAdHoverEnd,
      resolveAdUrl,
      routeName,
      sendEmail,
      base_url,
      property,
      same_area_properties,
      showContactInfoButtons,
      showContactDetails,
      townId,
      getPropertiesByTown,
      showPhoneNumber,
      isAuthenticated,
      shareWhatsApp,
      showPhoneDetails,
      message,
      wishlist: wishlistState.wishlist,
      handleAddItem,
      isInWishlist,
    };
  },
};
</script>

<style>
.icon {
  width: 24px; /* Adjust width as needed */
  height: 24px; /* Adjust height as needed */
}

.fill-white {
  fill: white; /* Change fill color to white */
}
</style>
